import { IAction } from '~/src/store';

import { EPaymentActions } from './index';

export type TFillPaymentSum = IAction<EPaymentActions.FILL_PAYMENT_SUM, number>

const fillPaymentSum = (paymentValue: number): TFillPaymentSum => ({
    type: EPaymentActions.FILL_PAYMENT_SUM,
    payload: paymentValue,
});

export default fillPaymentSum;
